import { render, staticRenderFns } from "./SettingsDialoge.vue?vue&type=template&id=752c31b3&"
import script from "./SettingsDialoge.vue?vue&type=script&lang=js&"
export * from "./SettingsDialoge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports